export default "__VITE_ASSET__DU3GeQy3__"